// src/utilities/fuzzySearch.js
import Fuse from 'fuse.js';

/**
 * Fuzzy Search Utility for Songs
 * Uses Fuse.js to provide fuzzy search functionality
 */
class FuzzySearchUtil {
    constructor() {
        this.fuse = null;
        this.songs = [];
    }

    /**
     * Initialize fuzzy search with songs data
     * @param {Array} songs - Array of song objects
     */
    initializeSearch(songs) {
        this.songs = songs;

        // Configure Fuse.js options
        const options = {
            includeScore: true,
            threshold: 0.4, // 0.0 requires perfect match, 1.0 matches anything
            ignoreLocation: true,
            keys: [
                {
                    name: 'song_name',
                    weight: 0.3
                },
                {
                    name: 'song_firstline',
                    weight: 0.3
                },
                {
                    name: 'song_number',
                    weight: 0.2
                },
                {
                    name: 'song_chorus',
                    weight: 0.1
                },
                {
                    name: 'section_name',
                    weight: 0.1
                }
            ]
        };

        this.fuse = new Fuse(songs, options);
    }

    /**
     * Search songs using fuzzy matching
     * @param {string} query - Search query
     * @returns {Array} Array of matching songs
     */
    search(query) {
        if (!this.fuse || !query.trim()) {
            return this.songs;
        }

        const results = this.fuse.search(query);
        return results.map(result => result.item);
    }

    /**
     * Get all songs without search
     * @returns {Array} All songs
     */
    getAllSongs() {
        return this.songs;
    }
}

// Export singleton instance
export const fuzzySearchUtil = new FuzzySearchUtil();
export default fuzzySearchUtil;